'use strict';

var propTypes = require('./prop-types.js');
var noop = require('./noop.js');
var getSafeDocumentBody = require('./get-safe-document-body.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./can-use-dom.js');
require('exenv');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Copy the passed value to the clipboard.
 *
 * @function
 * @param {string|number} value - The value to be copied.
 * @param {Function} callback - A callback to call when value is copied.
 * @returns {void}
 * @example
 * copyToClipboard('Text to clipboard!');
 */

var copyToClipboard = function copyToClipboard(value) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var tmpElement = document.createElement('div');
  tmpElement.innerText = value;
  getSafeDocumentBody().appendChild(tmpElement);
  var range = document.createRange();
  range.selectNodeContents(tmpElement);
  var selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  getSafeDocumentBody().removeChild(tmpElement);
  range.deleteContents();
  selection.removeAllRanges();
  callback(value);
};

copyToClipboard.HELPER_ID = 'Gearz.JsUtils.copyToClipboard';
copyToClipboard.returnType = undefined;
copyToClipboard.parameterTypes = {
  value: propTypes.oneOfTypeWithDescription([propTypes.number, propTypes.string], 'The value to be copied.'),
  callback: propTypes.funcWithDescription('Callback called when value is copied. `(valueCopied) => {}`')
};
copyToClipboard.defaultParameters = {
  value: undefined,
  callback: noop
};

module.exports = copyToClipboard;
